module.exports = __webpack_public_path__ + "media/images/lb/160-4e2bb5481a83050645a5c32a4c56f963.svg";